import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

export default [
  ['ADMIN', {
    path: '/website/pages',
  }],
  ['SELLER', {
    path: '/website/store/pages',
    archiveLoadUrl: '/pages',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Pages',
      // icon: 'layout',
      archiveLoadUrl: '/pages',
      archiveConfig: {
        title: 'Pages',
        label: 'Pages',
        // icon: 'layout',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
        createButtonPath: `${config.path}/create`,
      },
      // singleLoadUrl: '/pages/:id',
      singleLoadUrl: `/pages/:id/?${
        [
          'includeStoreData=true',
          'resolveContent=true',
        ].join('&')
      }`,
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        duplicateLoadUrl: '/pages/:duplicate',
      },
      singleCreateConfig: {
        headerTitle: 'New Page',
      },
      singleEditConfig: {
        actions: [
          ['ActionSave', {
            // handleSuccess: (data, props) => props.reload(),
          }],
          ['Action', {
            name: 'duplicate',
            title: 'Duplicate',
            type: 'primary',
            ghost: true,
            onClick: (props) => {
              props.history.push(
                `${config.path}/create?duplicate=${props.data._id}`
              );
            },
          }],
          ['ActionDelete'],
        ],
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/website/store/pages'
          : forRole === 'SELLER'
          ? '/website/pages'
          : null,
        ],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
